import { getRehabResult, setTab } from '@Actions';
import { type InspectionStandard } from '@Types';
import React from 'react';
import { useDispatch } from 'react-redux';
import RehabResultTable from './RehabResultTable';
import {
	type AssetTypeId,
	type SystemTypeId,
} from '@innovyze/lib_asset_schema';

export interface InspDetailActions {
	onInspectionDetailClicked?: (
		videoUrl: string,
		InspectionID: string,
		standard: InspectionStandard,
	) => void;
}

export interface AssetDetailActions {
	onAssetDetailClicked?: (
		assetId: string,
		systemType: SystemTypeId,
		assetType: AssetTypeId,
	) => void;
}

export interface RehabResultProps {
	readonly treeId: string;
	readonly lastRunCompleted?: string;
	readonly assetAction?: AssetDetailActions;
	readonly systemType: SystemTypeId;
	readonly assetType: AssetTypeId;
	readonly loadResults: boolean;
	onResultsLoaded: (loadResults: boolean) => void;
}

export default function RehabResult({
	treeId,
	lastRunCompleted,
	assetAction,
	systemType,
	assetType,
	loadResults,
	onResultsLoaded,
}: RehabResultProps) {
	// hooks
	const dispatch = useDispatch();

	// effects
	React.useEffect(() => {
		if (loadResults) {
			dispatch(getRehabResult());
			onResultsLoaded(false);
		}
	}, [treeId, loadResults]);
	React.useEffect(() => {
		dispatch(setTab('Results'));
	}, []);

	return (
		<>
			<RehabResultTable
				systemType={systemType}
				assetType={assetType}
				treeId={treeId}
				lastRunCompleted={lastRunCompleted}
				assetAction={assetAction}
			/>
		</>
	);
}
